import apiClient from "@/shared/services/api/apiClient";

export const getCandidateDashboard = async () => {
  const response = await apiClient.get(
    "/candidate-dashboard/dashboard",
    { showLoader: true } as any
  );

  return response.data;
};

export const downloadCandidateResume = async (
  applicationId: string
) => {
  return apiClient.get(
    `/candidate-dashboard/applications/${applicationId}/resume/download`,
    {
      responseType: "blob",
    }
  );
};

export const downloadCandidateVideo = async (
  applicationId: string
) => {
  return apiClient.get(
    `/candidate-dashboard/applications/${applicationId}/video/download`,
    {
      responseType: "blob",
    }
  );
};

export const downloadInterviewAttachment = async (
  attachmentId: string
) => {
  return apiClient.get(
    `/candidate-dashboard/interview-attachments/${attachmentId}/download`,
    {
      responseType: "blob",
    }
  );
};